"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importHolidaysRequestSchema = exports.holidayImportResultSchema = exports.updateHolidayRequestSchema = exports.createHolidayRequestSchema = exports.holidaySchema = exports.HOLIDAY_SOURCES = exports.HOLIDAY_KINDS = void 0;
const zod_1 = require("zod");
const identifier_1 = require("../identifier");
/* ⚠️ Declared here, like `people/contract.ts` and `contracts/contract.ts` do. `dates.ts` exports
   the CONVERTERS and no schema; a shared one would be the fourth thing named `wireDate` in this
   package and the smallest of the four. */
const wireDateSchema = zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ The workspace calendar — C42, Phase 3.                                    │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **NOT A LIST OF DAYS OFF.** Two kinds remove a working day and **the third ADDS one** — an
 * *áthelyezett munkanap* is a Saturday that is worked because a public holiday moved to a weekday.
 * `decisions.md` P3-3 says a model that reads this as *"days off"* gets the Hungarian calendar
 * wrong several times a year, and the name of every type here is chosen so that cannot be written.
 *
 * ⚠️ **The mockup's own vocabulary**, kept rather than tidied: these are the words the screen shows
 * and the words `PHASE-3.md` documents.
 */
exports.HOLIDAY_KINDS = ['public', 'rest', 'workday'];
/**
 * ⚠️⚠️ **PROVENANCE IS WHAT MAKES *"A RE-IMPORT MAY NOT OVERWRITE A HUMAN"* EXPRESSIBLE** (P3-3).
 * A row is `nager` until somebody touches it; from then on the importer leaves it alone for ever.
 */
exports.HOLIDAY_SOURCES = ['nager', 'custom'];
exports.holidaySchema = zod_1.z.object({
    id: zod_1.z.string(),
    /** The public identifier, `holiday_<8 hex>`, minted by the database (`0194`). */
    identifier: (0, identifier_1.identifierSchema)('holiday'),
    /** ⚠️ A calendar DATE. 20 August is 20 August in every timezone this is read from. */
    onDate: wireDateSchema,
    name: zod_1.z.string(),
    kind: zod_1.z.enum(exports.HOLIDAY_KINDS),
    source: zod_1.z.enum(exports.HOLIDAY_SOURCES),
    version: zod_1.z.number().int(),
});
/**
 * ⚠️ **`source` is absent from both write shapes, and that is the rule rather than an omission.**
 * Anything a person creates or edits is `custom` by definition — that IS the provenance rule — so
 * a client that could send `nager` could make its own row survive the next import.
 */
exports.createHolidayRequestSchema = zod_1.z.object({
    onDate: wireDateSchema,
    name: zod_1.z.string().trim().min(1).max(200),
    kind: zod_1.z.enum(exports.HOLIDAY_KINDS),
});
exports.updateHolidayRequestSchema = exports.createHolidayRequestSchema.extend({
    version: zod_1.z.number().int().nonnegative(),
});
/**
 * What an import answers with.
 *
 * ⚠️ **Three numbers rather than a list**, because the screen re-reads the year afterwards anyway
 * and the toast says *"N official days · Nager.Date · HU 2026"*. `kept` is the count the rule is
 * about: rows a person had touched, which the import did not reconcile away.
 */
exports.holidayImportResultSchema = zod_1.z.object({
    year: zod_1.z.number().int(),
    country: zod_1.z.string(),
    imported: zod_1.z.number().int().nonnegative(),
    kept: zod_1.z.number().int().nonnegative(),
});
exports.importHolidaysRequestSchema = zod_1.z.object({
    /** ⚠️ Bounded on the wire, not just in the UI: this is a network call to somebody else's API. */
    year: zod_1.z.number().int().min(2000).max(2100),
});
//# sourceMappingURL=calendar.js.map